import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import type { AppListing } from '@/backend/types';
import * as appsApi from '../api/apps';
import { appsByCreator } from '@/utils/searchApps';
import { EmptyState, IdentityChip, Screen } from '../ui';

/** Everything one creator has published. */
export default function Creator() {
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const [catalog, setCatalog] = useState<AppListing[]>([]);

  useEffect(() => {
    let live = true;
    void appsApi.fetchCatalog().then((list) => {
      if (live) setCatalog(list);
    }).catch(() => undefined);
    return () => {
      live = false;
    };
  }, []);

  const apps = useMemo(() => appsByCreator(catalog, id), [catalog, id]);

  return (
    <Screen title="Creator">
      {apps.length === 0 ? (
        <EmptyState icon="discover" title="Nothing published yet" body="This creator has no public apps." />
      ) : (
        <ul className="project-list app-grid">
          {apps.map((a) => (
            <li key={a.appId}>
              <button type="button" className="card clay-card pressable project-row" onClick={() => navigate(`/app/${a.appId}`)}>
                <IdentityChip name={a.name} />
                <span className="project-text">
                  <span className="type-heading">{a.name}</span>
                  <span className="type-caption project-meta">{a.description}</span>
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </Screen>
  );
}
